import cx from 'classnames';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { forwardRef } from 'react';

export const BoxSelectorLabel = forwardRef<
  ElementRef<'legend'>,
  BoxSelectorLabel.Props
>(function BoxSelectorLabel({ className, children, ...props }, ref) {
  return (
    <legend
      {...props}
      className={cx('box-selector__label', className)}
      ref={ref}
    >
      {children}
    </legend>
  );
});

BoxSelectorLabel.displayName = 'BoxSelectorLabel';

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace BoxSelectorLabel {
  export interface Props extends ComponentPropsWithoutRef<'legend'> {}
}
